import { c as _c } from "react/compiler-runtime";
import { UseIsVisibleType } from "@website/hooks/is-visible/is-visible.types";
import { RefObject, useEffect, useRef, useState } from "react";
export const useIsVisible: UseIsVisibleType = (options, defaultValue, rootReference) => {
  const $ = _c(6);
  const reference = useRef(null);
  const [inView, setInView] = useState(defaultValue || false);
  let t0;
  let t1;
  if ($[0] !== options || $[1] !== rootReference) {
    t0 = () => {
      const observer = new IntersectionObserver(t2 => {
        const [entry] = t2;
        return setInView?.(entry.isIntersecting);
      }, rootReference ? {
        ...options,
        root: rootReference.current
      } : options ?? {});
      const reference_ = reference.current;
      reference_ && observer?.observe(reference_);
      return () => {
        reference_ && observer?.unobserve(reference_);
      };
    };
    t1 = [options, rootReference];
    $[0] = options;
    $[1] = rootReference;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== inView) {
    t2 = {
      reference: reference as RefObject<HTMLDivElement>,
      inView
    };
    $[4] = inView;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};